/**
 * 
 * @param {array} arr Array of objects
 * @param {string} param Key of object for filtering
 * @returns {array} Modified array 
 */
export function removeDuplicates(arr, param) {
    return arr.filter((item, index, arr) => arr.findIndex((sItem) => (sItem[param] === item[param])) === index);
}
